/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface IsothermBlendingMode {
}

export enum IsothermBlendingMode_Enum {
  kSolid = 0,
  kTransparent = 1,
  kFollowY = 2,
  UNRECOGNIZED = -1,
}

export function isothermBlendingMode_EnumFromJSON(object: any): IsothermBlendingMode_Enum {
  switch (object) {
    case 0:
    case "kSolid":
      return IsothermBlendingMode_Enum.kSolid;
    case 1:
    case "kTransparent":
      return IsothermBlendingMode_Enum.kTransparent;
    case 2:
    case "kFollowY":
      return IsothermBlendingMode_Enum.kFollowY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IsothermBlendingMode_Enum.UNRECOGNIZED;
  }
}

export function isothermBlendingMode_EnumToJSON(object: IsothermBlendingMode_Enum): string {
  switch (object) {
    case IsothermBlendingMode_Enum.kSolid:
      return "kSolid";
    case IsothermBlendingMode_Enum.kTransparent:
      return "kTransparent";
    case IsothermBlendingMode_Enum.kFollowY:
      return "kFollowY";
    case IsothermBlendingMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseIsothermBlendingMode(): IsothermBlendingMode {
  return {};
}

export const IsothermBlendingMode = {
  encode(_: IsothermBlendingMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IsothermBlendingMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIsothermBlendingMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): IsothermBlendingMode {
    return {};
  },

  toJSON(_: IsothermBlendingMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<IsothermBlendingMode>, I>>(base?: I): IsothermBlendingMode {
    return IsothermBlendingMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IsothermBlendingMode>, I>>(_: I): IsothermBlendingMode {
    const message = createBaseIsothermBlendingMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
